import {IController, IModule, IOnChangesObject} from "angular";
import {Kontekst} from "felles/tjenester/Kontekst";
import {l} from "types/typescriptdefinisjoner_lederplan";
import _ from "lodash";
import {WebNavigasjon} from "web/tjenester/WebNavigasjon";
import {changesInneholder} from "felles/stoettefunk/angularHjelpemetoder";

const css = require('./brukere.scss');

export class OrgBrukereKontroller implements IController {

    static registrerKomponent(angular: IModule) {
        angular
            .component('wmAvtaleBrukere', {
                bindings: {avtale: '<'},
                controller: OrgBrukereKontroller.forInjisering(),
                template: require('./brukere.html')
            });
    }

    static forInjisering() {
        return [
            WebNavigasjon.regNavn,
            Kontekst.regNavn,
            OrgBrukereKontroller
        ]
    }

    constructor(private webNavigasjon: WebNavigasjon,
                private kontekst: Kontekst) {
    }

    avtale: l.AvtaledetaljerModell; //settes via bindings/$onChanges

    brukere: l.EnkelBrukerModell[];

    private valgtBruker: l.EnkelBrukerModell;
    private brukeresGrupper: { [brukerId: string]: GruppeOgMedlem[] };

    velgBruker(bruker: l.EnkelBrukerModell) {
        this.valgtBruker = bruker;
    }

    fjernValgtBruker(bruker: l.EnkelBrukerModell) {
        this.valgtBruker = null;
    }

    brukerValgt(bruker: l.EnkelBrukerModell) {
        return this.valgtBruker && this.valgtBruker.id === bruker.id;
    }

    noenBrukerValgt() {
        return !_.isNil(this.valgtBruker);
    }

    brukersGrupper(bruker: l.EnkelBrukerModell): GruppeOgMedlem[] {
        return this.brukeresGrupper[bruker.id];
    }

    gaaTilMedlem(gruppeOgMedlem: GruppeOgMedlem) {
        if (!gruppeOgMedlem.tilgjengeligForInnloggetBruker) return;
        this.webNavigasjon.gåTilMedlem(gruppeOgMedlem.gruppe.id, gruppeOgMedlem.medlem.id);
    }

    $onChanges(changes: IOnChangesObject): void {
        if (changesInneholder(changes, 'avtale')) {
            this.setData();
        }
    }

    // hjelpemetoder

    private setData() {
        this.brukeresGrupper = this.beregnBrukeresGrupper();
        this.brukere = this.aktiveBrukere();
    }

    private aktiveBrukere() {
        return this.avtale.aktiveBrukere;
    }

    private beregnBrukeresGrupper() {
        return _(this.avtale.aktiveBrukere)
            .keyBy(bruker => bruker.id)
            .mapValues((bruker: l.EnkelBrukerModell) => this.beregnBrukersGrupper(bruker))
            .value();
    }

    private beregnBrukersGrupper(bruker: l.EnkelBrukerModell): GruppeOgMedlem[] {
        return _(this.avtale.grupper)
            .map(gruppe => ({
                gruppe: gruppe,
                medlem: _(gruppe.medlemmer).findLast(medlem => medlem.brukerId === bruker.id),
                tilgjengeligForInnloggetBruker: this.kontekst.harTilgangTilGruppe(gruppe.id)
            }))
            .filter(gruppeOgMedlem => !_.isNil(gruppeOgMedlem.medlem))
            .value()
    }
}

interface GruppeOgMedlem {
    gruppe: l.GruppeModell;
    medlem: l.GruppeMedlemListeModell;
    tilgjengeligForInnloggetBruker: boolean;
}
